import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { WhitelistConfigType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { getWhitelistInfo } from 'services/api/payments'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* setupStep() {
  const data: Response<WhitelistConfigType> = yield call(getWhitelistInfo)

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'loading', false))
  yield put(actions.payments.setWhitelistAddresses(data.response.whitelisted))
  yield put(actions.payments.setWhitelistCapabilities(data.response.capabilities))

  yield call(goToStep, 'addaddress')
}
